import { render, staticRenderFns } from "./ChannelDropdown.vue?vue&type=template&id=482e250c&scoped=true"
import script from "./ChannelDropdown.vue?vue&type=script&lang=js"
export * from "./ChannelDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChannelDropdown.vue?vue&type=style&index=0&id=482e250c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e250c",
  null
  
)

export default component.exports